import React from "react";
import { useCommandContext } from "utils/context/command";
import { COMMAND_TYPE_ICON_MAP } from "./constants";
import { getItemProps } from "./utils";

const Item = ({ item, index }) => {
  const { values, actions } = useCommandContext();
  const addHistory = actions.addHistory;
  const reset = actions.reset;

  const itemProps = getItemProps({
    item,
    index,
    currentIndex: values.index,
    /**
     * Note: this is the default onClick handler
     * - Can be override by a more specific perform handler on the item
     */
    onClick: () => {
      addHistory(item.id);
    },
    afterClick: reset,
    actions
  });
  let iconNode;
  const Icon = item.type && COMMAND_TYPE_ICON_MAP[item.type];
  if (Icon) {
    iconNode = (
      <div className="fr">
        <Icon size={20} />
      </div>
    );
  }

  return (
    <div {...itemProps}>
      {item.name}
      {iconNode}
    </div>
  );
};

export default Item;
